import { Button } from "../../button";
import { Icon } from "../../icons";
import { useTranslation } from "../../localization";
import { useDataTableContext } from "./context";

export function DataTablePagination() {
	/** Context */
	const { table } = useDataTableContext();

	/** Hooks */
	const { t } = useTranslation();

	/** Computed */
	const pageCount = table.getPageCount();

	/** Functions */
	function handleGoBack() {
		table.previousPage();
	}

	function handleGoForward() {
		table.nextPage();
	}

	/** Render */
	return (
		<div className="flex flex-row items-center gap-2">
			<p className="mr-2">
				{t("misc.pagination.page")}{" "}
				<span data-cy="data-table-pagination-current-page">
					{table.state.pagination.pageIndex + 1}
				</span>{" "}
				{t("misc.pagination.of")}{" "}
				<span data-cy="data-table-pagination-total-pages">{Math.max(pageCount, 1)}</span>
			</p>
			<Button
				icon={<Icon name="ChevronLeft" />}
				size="xxs"
				onClick={handleGoBack}
				isDisabled={!table.getCanPreviousPage()}
				data-cy="data-table-pagination-prev-button"
			/>
			<Button
				icon={<Icon name="ChevronRight" />}
				size="xxs"
				onClick={handleGoForward}
				isDisabled={!table.getCanNextPage()}
				data-cy="data-table-pagination-next-button"
			/>
		</div>
	);
}
